import { render, staticRenderFns } from "./AlarmHistoryView.vue?vue&type=template&id=2ad4ae14&scoped=true&"
import script from "./AlarmHistoryView.vue?vue&type=script&lang=ts&"
export * from "./AlarmHistoryView.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmHistoryView.vue?vue&type=style&index=0&id=2ad4ae14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad4ae14",
  null
  
)

export default component.exports